<template>
  <v-btn v-on:click="dialog = true" variant="text" rounded="xl" icon>
    <v-icon :icon="['fas', 'filter']" />
  </v-btn>

  <v-dialog persistent max-width="500" scrollable v-model="dialog">
    <v-card title="РЕДАКТОР ФИЛЬТРОВ" rounded="xl">
      <template v-slot:append v-if="!clean_selection && !cleared">
        <v-btn
            density="compact"
            color="red"
            rounded="xl"
            flat
            text="ОЧИСТИТЬ"
            @click="clear_filters()"
        />
      </template>
      <v-card-text>
        <v-select
            rounded="0" flat
            hide-details
            label="Ответственный"
            :items="chiefs"
            item-title="name"
            item-value="guid"
            v-model="f.chiefs"
            class="mb-2"
        >
        </v-select>
        <v-select
            rounded="0" flat
            hide-details
            label="Контрагенты"
            :items="agents"
            item-title="name"
            item-value="guid"
            v-model="f.agents"
            multiple>
          <template v-slot:selection>
            <v-avatar size="10" color="green" />
          </template>
        </v-select>
        <v-select
            rounded="0" flat
            hide-details
            label="Физ.объекты"
            :items="objects"
            item-title="name"
            item-value="guid"
            v-model="f.objects"
            multiple>
          <template v-slot:selection>
            <v-avatar size="10" color="orange" />
          </template>
        </v-select>
        <v-select
            rounded="0" flat
            hide-details
            label="Типы работ"
            :items="types"
            item-title="name"
            item-value="guid"
            v-model="f.types"
            multiple>
          <template v-slot:selection>
            <v-avatar size="10" color="cyan" />
          </template>
        </v-select>
        <v-select
            rounded="0" flat
            hide-details
            label="Периодичность"
            :items="period"
            item-title="name"
            item-value="guid"
            v-model="f.period"
            multiple>
          <template v-slot:selection>
            <v-avatar size="10" color="yellow" />
          </template>
        </v-select>
      </v-card-text>

      <v-card-actions>
        <v-btn
            rounded="xl"
            flat
            text="ОТМЕНА"
            @click="deny_changes()"
        />
        <v-spacer />
        <v-btn
            class="font-weight-bold"
            rounded="xl"
            flat
            :text="clean_selection ? 'ОЧИСТИТЬ ФИЛЬТРЫ' :'ПРИМЕНИТЬ'"
            @click="confirm_filters()"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ZN_Filters, ZN_FiltersFrom1C } from "@/store/zn_planner/Filters";
import { OriginalDocuments } from "@/store/zn_planner/Documents";
import { UserStore } from "@/store/GigaUser";

export default {
  name: "ZN_Filter",
  beforeMount() {
    this.generate_lists()
  },
  mounted() {
    /*if (this.chiefs.find(chief => chief.guid = this.user.guid_person)) {
      this.filters = {
        agents: this.f.agents,
        objects: this.f.objects,
        types: this.f.types,
        period: this.f.period,
        chiefs: this.user.guid_person
      }
      this.f.chiefs = this.user.guid_person
    }*/
  },
  data() {
    return {
      dialog: false,
      cleared: false,
      agents: [],
      objects: [],
      chiefs: [],
      types: [],
      period: [],
      f: {
        agents: [],
        objects: [],
        types: [],
        period: [],
        chiefs: [],
      },
      f_tmp: {
        agents: [],
        objects: [],
        types: [],
        period: [],
        chiefs: [],
      }
    }
  },
  methods: {
    deny_changes: function () {
      if (this.cleared) {
        this.f = this.f_tmp
      }
      this.dialog = false
      this.cleared = false
    },
    confirm_filters: function () {
      this.filters = {
        agents: this.f.agents,
        objects: this.f.objects,
        types: this.f.types,
        period: this.f.period,
        chiefs: this.f.chiefs
      }

      this.dialog = false
      this.cleared = false
    },
    clear_filters: function () {
      this.cleared = true
      this.f_tmp = JSON.parse(JSON.stringify(this.f))
      this.f = {
        agents: [],
        objects: [],
        types: [],
        period: [],
        chiefs: []
      }
    },
    generate_lists: function () {
      for (let doc of this.filters_from1C) {
        this.objects.push(doc.object)
        this.types.push(doc.type)
        this.agents.push(doc.agent)
        this.period.push(doc.period)
        this.chiefs.push(doc.chief)
      }
      this.agents = Array.from(new Set(this.agents.map(JSON.stringify))).map(JSON.parse);
      this.types = Array.from(new Set(this.types.map(JSON.stringify))).map(JSON.parse);
      this.objects = Array.from(new Set(this.objects.map(JSON.stringify))).map(JSON.parse);
      this.period = Array.from(new Set(this.period.map(JSON.stringify))).map(JSON.parse);
      this.chiefs = Array.from(new Set(this.chiefs.map(JSON.stringify))).map(JSON.parse);
    }
  },
  computed: {
    count_of_filters() {
      let count = 0
      let keys = Object.keys(this.filters)
      console.log(keys)

      for (let key of keys) {
        count += this.filters[key].length
      }
      return count
    },
    user: {
      get() {
        return UserStore().get()
      },
      set(value) {
        UserStore().set(value)
      }
    },
    clean_selection() {
      return this.f.agents.length === 0 && this.f.objects.length === 0 && this.f.types.length === 0 && this.f.period.length === 0 && this.f.chiefs.length === 0
    },
    filters_from1C: {
      get() {
        return ZN_FiltersFrom1C().get()
      },
      set(value) {
        ZN_FiltersFrom1C().set(value)
      }
    },
    filters: {
      get() {
        return ZN_Filters().get()
      },
      set(value) {
        ZN_Filters().set(value)
      }
    },
    documents_o: {
      get() {
        return OriginalDocuments().get()
      },
      set(value) {
        OriginalDocuments().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
